import { IContent } from '@_entities/content';
import { UseContentActionReturn, ContentAction } from '../../model';
import {
	useDeleteContentMutation,
	useUpdateContentFolderMutation,
	useUpdateContentTitleMutation,
	usePinContentMutation,
} from '../mutation';

export function useContentAction(content: IContent): UseContentActionReturn {
	const { updateTitle } = useUpdateContentTitleMutation(content);
	const { deleteContent } = useDeleteContentMutation(content);
	const { updateFolder } = useUpdateContentFolderMutation(content);
	const { pinContent } = usePinContentMutation(content);

	function dispatch(action: ContentAction) {
		switch (action.type) {
			case 'UPDATE_TITLE':
				updateTitle(action.title);
				break;
			case 'UPDATE_FOLDER':
				updateFolder(action.updatedFolderId);
				break;
			case 'DELETE_CONTENT':
				deleteContent();
				break;
			case 'PIN_CONTENT':
				pinContent({
					contentFixed: action.contentFixed,
					folderId: content.folderId,
					pinType: action.pinType,
				});
				break;
			default:
				throw new Error('Invalid action');
		}
	}

	return {
		dispatch,
	};
}
